// anthropicClient.js — browser → Ops Hub Anthropic PROXY.
//
// The Anthropic API key is no longer sent to the browser. A small server-side proxy
// (Azure App Service — see proxy/) holds the key, verifies the caller's Entra bearer,
// and forwards to the Anthropic Messages API. The proxy is NOT behind Azure Static Web
// Apps, so it reads the standard Authorization header (not the X-Ops-Auth header the
// SWA-hosted /api routes need). Used by the One-Pager Builder and PDF → Markdown.
import { getApiToken } from "../auth/apiToken.js";

export const PROXY_MESSAGES_URL = "https://sawtooth-ops-anthropic.azurewebsites.net/api/messages";
export const PROXY_DRAFT_URL = "https://sawtooth-ops-anthropic.azurewebsites.net/api/meetings/draft";

// Headers for a proxy call: JSON + the Entra bearer, plus any extra headers (e.g.
// anthropic-beta for web search, which the proxy forwards to Anthropic).
export async function proxyHeaders(extra = {}) {
  const token = await getApiToken();
  const headers = { "Content-Type": "application/json", ...extra };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

/** Non-streaming Messages call via the proxy. Throws Error(message) on non-2xx. */
export async function callAnthropicDirect(body, extraHeaders = {}) {
  const res = await fetch(PROXY_MESSAGES_URL, {
    method: "POST",
    headers: await proxyHeaders(extraHeaders),
    body: JSON.stringify(body),
  });
  const text = await res.text();
  if (!res.ok) {
    let msg = `Anthropic API error: ${res.status}`;
    try { const e = JSON.parse(text); msg = e?.error?.message || e?.error || msg; } catch (_) {}
    throw new Error(msg);
  }
  return JSON.parse(text);
}

/** Generate an update-meeting draft from a source packet. Never throws: { ok, status, data }. */
export async function draftMeeting(packet) {
  try {
    const res = await fetch(PROXY_DRAFT_URL, { method: "POST", headers: await proxyHeaders(), body: JSON.stringify({ packet }) });
    const data = await res.json().catch(() => ({}));
    return { ok: res.ok, status: res.status, data };
  } catch {
    return { ok: false, status: 0, data: { error: "Network error — check your connection and try again." } };
  }
}
